export default __webpack_public_path__ + "static/media/ceee.29f2e9b4.svg";